import * as React from 'react';
import { Pulse } from 'better-react-spinkit';

interface ILoadingProps {
  size ?: number;
}

class Loading extends React.Component<ILoadingProps, any> {
  public static defaultProps: Partial<ILoadingProps> = {
    size: 25,
  };

  public render() {
    return <Pulse className="loading-icon" style={{maxWidth: this.props.size}} size={this.props.size} />;
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/Loading/index.tsx